import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedNumber} from "react-intl";

import {styled} from "@mui/material/styles";

import {black500, greyishBlue200, greyishBlue600} from "assets/jss/main";

ListingTotalCount.propTypes = {
    labelId: PropTypes.string.isRequired,
    total: PropTypes.number,
};

const Container = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px'
});

const CountText = styled('span')({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color: greyishBlue600,
    fontSize: '12px',
    fontWeight: 400,
    whiteSpace: 'nowrap'
});

const SelectWrapper = styled('div')({
    '& .MuiInputBase-root': {
        height: '40px',
        marginTop: 'unset',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: black500,
        fontSize: '14px',
        fontWeight: 600,
        '& fieldset': {
            borderColor: greyishBlue200
        }
    },
    '& .MuiSelect-icon': {
        color: black500,
        width: '20px',
        height: '20px',
        top: 'calc(50% - 10px)'
    }
});

function ListingTotalCount({labelId, total, children}) {
    return (
        <Container>
            {(total !== undefined && total !== null) && (
                <CountText>
                    <FormattedMessage id={labelId}/>
                    <FormattedNumber value={total}/>
                </CountText>
            )}
            <SelectWrapper>
                {children}
            </SelectWrapper>
        </Container>
    );
}

export default ListingTotalCount;
